import React from "react";
import { Button } from "@design-system/Button/Button";
import { usePlanManagement } from "../PlanManagement/PlanManagementContext";

interface Props {
    variant: "primary" | "tertiary";
    size?: "sm" | "md" | "lg" | "xl";
    className?: string;
    children: React.ReactNode | ((convert: () => void) => React.ReactNode);
}

export const EndTrialAction: React.FC<Props> = ({
    children,
    size,
    variant,
    className,
}) => {
    const { convert } = usePlanManagement();

    if (typeof children === "function") {
        return children(convert);
    }

    return (
        <Button
            {...(variant === "primary"
                ? { variant: "primary", size: size ?? "md" }
                : { variant: "tertiary", size: size ?? "md" })}
            className={className}
            onClick={convert}
        >
            {children}
        </Button>
    );
};
